var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{attrs:{"outlined":"","dense":"","text":"","icon":_vm.icon,"type":_vm.type,"dismissible":_vm.dismissible},on:{"input":function($event){return _vm.$emit('close')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }